import React from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { allProductsById, allProductsByPrimaryTreeId } from 'shared/api/masters'
import { useSearchParams } from 'shared/hooks'
import { useNavigateWithSearch, useParams } from 'infrastructure/routing'
import { ProductSelection } from '../tree/products/ProductSelection'

export function ProductNavigation() {
  const allProducts = useAtomValue(allProductsById)
  const allProductsByTreeId = useAtomValue(allProductsByPrimaryTreeId)
  const [search] = useSearchParams()
  const { treeId } = useParams()
  const navigate = useNavigateWithSearch()

  const productId = treeId ? allProductsByTreeId[treeId]?.id : undefined
  const onProductSelect = ({ id }: { id: number }) => {
    const { primary_tree_tree_id } = allProducts[id]
    navigate({
      pathname: `/masters/${primary_tree_tree_id}`,
      search: search.toString(),
    })
  }
  return (
    <ProductSelection
      onSelect={onProductSelect}
      selectedProductId={productId}
    />
  )
}
